import tmhRequest from '@/config/tmhRequest'

export default {
  searchRoom: function ( data) {
    return tmhRequest({
      url: '/store/tmh/room/searchroom',
      method: 'post',
      params: data,
    })
  },
  searchListRoom: function ( data) {
    return tmhRequest({
      url: '/store/tmh/room/searchlistroom',
      method: 'post',
      params: data,
    })
  },
  searchRoomCount: function ( data) {
    return tmhRequest({
      url: '/store/tmh/room/searchroomcount',
      method: 'post',
      params: data,
    })
  },
  searchRoomByPage: function ( data) {
    return tmhRequest({
      url: '/store/tmh/room/searchroombypage',
      method: 'post',
      params: data,
    })
  },
  addRoom: function ( data) {
    return tmhRequest({
      url: '/store/tmh/room/addroom',
      method: 'post',
      params: data,
    })
  },
  editRoom: function ( data) {
    return tmhRequest({
      url: '/store/tmh/room/editroom',
      method: 'post',
      params: data,
    })
  },
  deleteRoom: function ( data) {
    return tmhRequest({
      url: '/store/tmh/room/deleteroom',
      method: 'post',
      data: data,
    })
  },
}


// WEBPACK FOOTER //
// ./src/api/tmh/store/room.js